import { render, staticRenderFns } from "./UnidadeNegocioList.vue?vue&type=template&id=79836987"
import script from "./UnidadeNegocioList.vue?vue&type=script&lang=js"
export * from "./UnidadeNegocioList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports